export const settingsExtractedMessages = {
  "settings.LibraryImportPanel.action": "Action",
  "settings.LibraryImportPanel.book": "Book",
  "settings.LibraryImportPanel.chooseAction": "Choose action",
  "settings.LibraryImportPanel.errors": "errors ·",
  "settings.LibraryImportPanel.goodreadsOrCsvFile": "Kindle, Goodreads, or CSV file",
  "settings.LibraryImportPanel.importComplete": "Import complete",
  "settings.LibraryImportPanel.imported": "imported ·",
  "settings.LibraryImportPanel.imported2": "Imported",
  "settings.LibraryImportPanel.importNeedsAttention": "Import needs attention",
  "settings.LibraryImportPanel.importValidationAndMatchingResults":
    "Import validation and matching results",
  "settings.LibraryImportPanel.needDecisions": "need decisions",
  "settings.LibraryImportPanel.nextRows": "Next rows",
  "settings.LibraryImportPanel.preview": "preview",
  "settings.LibraryImportPanel.previousRows": "Previous rows",
  "settings.LibraryImportPanel.result": "Result",
  "settings.LibraryImportPanel.row": "Row",
  "settings.LibraryImportPanel.rows": "rows ·",
  "settings.LibraryImportPanel.rowsRequiringCorrection": "rows requiring correction.",
  "settings.LibraryImportPanel.saveDecisionsForThisPage":
    "Save decisions for this page",
  "settings.LibraryImportPanel.skipped": "skipped ·",
  "settings.LibraryImportPanel.skipped2": ", skipped",
  "settings.LibraryImportPanel.utf8CsvUpTo5Mb":
    "UTF-8 CSV, up to 5 MB and 5,000 rows. Kindle files need Title, Author, and ASIN columns; Reading Status and Current Page are optional.",
  "settings.LibraryImportPanel.validateAndPreview": "Validate and preview",
  "settings.LibraryImportPanel.with": ", with",
  "settings.LibraryImportPanel.historyTitle": "Import history",
  "settings.LibraryImportPanel.historyDescription":
    "Review each import and safely roll back changes that have not been edited since.",
  "settings.LibraryImportPanel.noHistory": "No imports yet.",
  "settings.LibraryImportPanel.historyCaption": "Owner-scoped import history",
  "settings.LibraryImportPanel.source": "Source",
  "settings.LibraryImportPanel.started": "Started",
  "settings.LibraryImportPanel.completed": "Completed",
  "settings.LibraryImportPanel.counts": "Imported / skipped / warnings",
  "settings.LibraryImportPanel.rollback": "Rollback status",
  "settings.LibraryImportPanel.actions": "Actions",
  "settings.LibraryImportPanel.conflicts": "conflicts",
  "settings.LibraryImportPanel.viewChanges": "View exact changes",
  "settings.LibraryImportPanel.rollbackImport": "Roll back import",
  "settings.LibraryImportPanel.exactChanges":
    "Exact entities and relationships changed",
  "settings.LibraryImportPanel.noChanges": "This import did not change any records.",
  "settings.LibraryImportPanel.stateDetails": "View before and after state",
  "settings.LibraryImportPanel.previousImports": "Previous imports",
  "settings.LibraryImportPanel.nextImports": "Next imports",
  "settings.SettingsPage.account": "Account",
  "settings.SettingsPage.biography": "Biography",
  "settings.SettingsPage.cancel": "Cancel",
  "settings.SettingsPage.chooseANewPasswordWithoutChangingThe":
    "Choose a new password without changing the rest of your profile.",
  "settings.SettingsPage.confirmNewPassword": "Confirm new password",
  "settings.SettingsPage.controlsForTakingYourReadingHistoryWith":
    "Controls for taking your reading history with you and managing privacy.",
  "settings.SettingsPage.currentPassword": "Current password",
  "settings.SettingsPage.dataPrivacy": "Data & privacy",
  "settings.SettingsPage.deleteAccount": "Delete account",
  "settings.SettingsPage.deletePermanently": "Delete permanently",
  "settings.SettingsPage.detectedTimezone": "Detected timezone",
  "settings.SettingsPage.downloadYourProfileLibraryJournalGoalsOrganization":
    "Download your profile, library, journal, goals, organization, and import history as JSON.",
  "settings.SettingsPage.email": "Email",
  "settings.SettingsPage.export": "Export",
  "settings.SettingsPage.exportReadingData": "Export reading data",
  "settings.SettingsPage.exportPrivateQuotes": "Export private quotes",
  "settings.SettingsPage.quoteExportHelp":
    "Citation-friendly CSV or Markdown. Spoilers are excluded by default; this is not a formal citation standard.",
  "settings.SettingsPage.exportCsv": "Export CSV",
  "settings.SettingsPage.exportMarkdown": "Export Markdown",
  "settings.SettingsPage.quoteExportDownloaded":
    "Your private quote export has downloaded.",
  "settings.SettingsPage.fullName": "Full name",
  "settings.SettingsPage.journalEntriesUseTheTimezoneCapturedWhen":
    "Journal entries use the timezone captured when each session is logged.",
  "settings.SettingsPage.jpegPngOrWebpMaximum2Mb": "JPEG, PNG, or WebP. Maximum 2 MB.",
  "settings.SettingsPage.keepYourAccountDetailsClearPrivateAnd":
    "Keep your account details clear, private, and up to date.",
  "settings.SettingsPage.lastUsed": "Last used",
  "settings.SettingsPage.manageAccessToYourCelsusAccount":
    "Manage access to your Celsus account.",
  "settings.SettingsPage.newPassword": "New password",
  "settings.SettingsPage.offByDefaultEachAdditionalReadingSurface":
    "Off by default. Each additional reading surface is a separate choice.",
  "settings.SettingsPage.passwordForAccountDeletion": "Password for account deletion",
  "settings.SettingsPage.permanentlyDeleteAccount": "Permanently delete account?",
  "settings.SettingsPage.permanentlyRemoveYourAccountAndAllPrivate":
    "Permanently remove your account and all private Celsus data. Export first if you want to keep a copy.",
  "settings.SettingsPage.profile": "Profile",
  "settings.SettingsPage.profilePicture": "Profile picture",
  "settings.SettingsPage.publicCommunityProfile": "Public community profile",
  "settings.SettingsPage.publicDisplayName": "Public display name",
  "settings.SettingsPage.readingPreferences": "Reading preferences",
  "settings.SettingsPage.revoke": "Revoke",
  "settings.SettingsPage.revokeAccessYouNoLongerRecognize":
    "Revoke access you no longer recognize.",
  "settings.SettingsPage.savePrivacyChoices": "Save privacy choices",
  "settings.SettingsPage.saveProfile": "Save profile",
  "settings.SettingsPage.security": "Security",
  "settings.SettingsPage.settings": "Settings",
  "settings.SettingsPage.shelvesToPublish": "Shelves to publish",
  "settings.SettingsPage.signedInDevices": "Signed-in devices",
  "settings.SettingsPage.signOut": "Sign out",
  "settings.SettingsPage.signOutEverywhere": "Sign out everywhere",
  "settings.SettingsPage.theNameAndContactDetailsConnectedTo":
    "The name and contact details connected to your account.",
  "settings.SettingsPage.thisPermanentlyDeletesYourProfileLibraryEntries":
    "This permanently deletes your profile, library entries, reading sessions, goals, collections, tags, and import history. It cannot be undone.",
  "settings.SettingsPage.timezonePreferencesCannotBeChangedYetCelsus":
    "Timezone preferences cannot be changed yet. Celsus records this detected timezone with each new session.",
  "settings.SettingsPage.typeDeleteMyAccountToConfirm":
    'Type "DELETE MY ACCOUNT" to confirm',
  "settings.SettingsPage.updatePassword": "Update password",
  "settings.SettingsPage.username": "Username",
  "settings.SettingsPage.youCanSignBackInAtAny": "You can sign back in at any time.",
} as const;
